<template>
    <div class="login-box">
        <form class="form-horizontal">
            <div class="form-group">
                <label class="col-sm-5 control-label">
                    账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号:
                </label>
                <div class="col-sm-3">
                    <input type="text" v-model="loginModel.username" value="" /> 
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-5 control-label">
                    密&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;码:
                </label>
                <div class="col-sm-3">
                    <input type="password" v-model="loginModel.password" value="" />
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-offset-5 col-sm-2">
                    <span class="btn btn-info" v-on:click="login"  @keyup.enter="login">
                        登 录
                    </span>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loginModel: {
                username: '',
                password: ''
            }
        };
    },
    methods: {
        login() {
            var _this = this;
            _this.$common.my_ajax({
                url: '/localUser/adminLogin',
                data: _this.loginModel,
                success: function(response) {
                    var loginItem = response.item;
                    if (response.item) {
                        _this.$common.cacheToken(loginItem.token);
                        _this.$common.user_info(loginItem);
                        _this.$router.push({ name: 'home' });
                        _this.$common.cache("menus",loginItem.menus);
                        _this.$common.cache("menusList",loginItem.menusList);
                        _this.$common.enum_config_init();
                    } else {
                        _this.$message({
                            message: '账号或密码错误',
                            type: 'warning'
                        });
                    }
                }
            });
        }
    }
}
</script>
<style scoped>
.login-box{background-size:100% ; padding:inherit;}
.form-horizontal {
    width: 400px;
    height: 240px;
    padding-right: 80px;
    background: linear-gradient(to bottom right,#688bf5,#8bc8f5);
    padding-top: 40px;
    position: fixed;
    top: 52%;
    left: 50%;
    margin-top: -120px;
    margin-left: -200px;
    color: #fff;
    border-radius:20px;
    box-shadow: 2px 0 12px 0;
}
.btn-info{    width: 110px;
    background: #fff;
    color: #000;
    font-size:14px;
    font-weight:bold;
    }
.form-horizontal input{ height:40px; line-height:40px; color:#999; padding:0 10px;}
/*改进后台登录样式end*/
</style>